import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { UserService } from "../../../../services/user.service";
import { PlanService } from "../../../../services/plan.service";
import { AppConfig } from "../../../../configs/app";

declare var Cleave: any;

@Component({
  selector: "page-profile-index",
  templateUrl: "./index.component.html",
})
export class PageProfileIndexComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public userData: any = {};

  public userDataForm: FormGroup;

  public userDeteleForm: FormGroup;

  public deleteOn = "on";

  public checkboxes = {
    checkbox1: "off",
    checkbox2: "off",
    checkbox3: "off",
  };

  public divisionData: any;

  /* CUSTOM VALIDATOR */
  public myValidator: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  /* NEW MEMBER CHECK DATA */
  public emailNUsernameCheckData: any = {
    email: {
      hasError: false,
      errorMessage: "",
      successMessage: "",
    },
    username: {
      hasError: false,
      errorMessage: "",
      successMessage: "",
    },
    isChecking: false,
  };

  constructor(
    public formBuilder: FormBuilder,
    public authService: AuthService,
    public commonService: CommonService,
    public userService: UserService,
    public planService: PlanService,
    public appConfig: AppConfig
  ) {
    let self = this;
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();

    /* CUSTOM VALIDATOR */
    this.myValidator.isNumeric = function (control: AbstractControl): any {
      if (
        control.value &&
        control.value != "" &&
        !self.commonService.isNumeric(control.value)
      ) {
        return { isNumeric: true };
      }
      return null;
    };

    this.myValidator.isKana = function (control: AbstractControl): any {
      if (!self.commonService.isKana(control.value)) {
        return { isKana: true };
      }
      return null;
    };

    this.myValidator.validateDate = function (control: AbstractControl): any {
      let date = control.value.toString().replace(/[/]/g, "");
      if (date.length < 6) {
        return { cardDate: true };
      }

      /* CHECK INVALID DATE */
      if (
        !self.moment(date, "YYYYMMDD", true).isValid() ||
        self.moment(date, "YYYYMMDD").valueOf() > self.moment().valueOf()
      ) {
        return { cardDate: true };
      }
      return null;
    };

    this.myValidator.isRomanAlphabetNNumber = function (
      control: AbstractControl
    ): any {
      if (!self.commonService.isRomanAlphabetNNumber(control.value)) {
        return { isRomanAlphabetNNumber: true };
      }
      return null;
    };
  }

  async ngOnInit() {
    /* SET PAGE TITLE */
    this.commonService.setTitle(`私のプロフィール | バスブックマーク`);

    /* CHECK IF NOT LOGGED IN */
    if (!this.authService.isLoggedIn()) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageHomeNoParam
      );
    }

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET DIVISION DATA */
    this.divisionData = await this.planService.getDivisions();
    delete this.divisionData.division_root[0];
    /* END */

    /* GET USER DATA */
    this.userData = await this.userService.getProfileInfo();

    /* MAKE SOCIAL USERS MAP */
    this.makeSocialUserMap();

    this.userData.age = this.moment().diff(this.userData.birth_date, "years");

    let birthday = this.userData.birth_date
      ? this.userData.birth_date.replace(/-/g, "")
      : "19701010";

    let mail_magazine_type = this.userData.mail_magazine1_type == "2" ? 1 : 0;

    this.userDataForm = this.formBuilder.group({
      sei_kana: [
        this.userData.sei,
        [Validators.required, this.myValidator.isKana],
      ],
      mei_kana: [
        this.userData.mei,
        [Validators.required, this.myValidator.isKana],
      ],
      sex_type: [this.userData.sex_type, Validators.required],
      pref_id: [this.userData.pref_id, Validators.required],
      birth_date: [
        birthday,
        [Validators.required, this.myValidator.validateDate],
      ],
      tel: [
        this.userData.tel,
        [
          Validators.required,
          this.myValidator.isNumeric,
          Validators.minLength(10),
          Validators.maxLength(11),
        ],
      ],
      email1: [this.userData.email1, [Validators.required, Validators.email]],
      email2: [this.userData.email2, Validators.email],
      mail_magazine1_type: [mail_magazine_type],
      mail_magazine2_type: [mail_magazine_type],
      mail_magazine3_type: [mail_magazine_type],
      username: [
        this.userData.username,
        [
          Validators.required,
          Validators.minLength(6),
          this.myValidator.isRomanAlphabetNNumber,
        ],
      ],
      new_password: [
        "",
        [Validators.minLength(7), this.myValidator.isRomanAlphabetNNumber],
      ],
    });

    this.tempData.formSubmitted = false;
    /* END */

    /* GET USER DELETE DATA */
    this.userDeteleForm = this.formBuilder.group({
      checkbox1: [false],
      checkbox2: [false],
      checkbox3: [false],
    });
    /* END */

    /* SOCIAL ACCOUNT LINKED STATUS */
    this.tempData.socialAccountLinkedStatus = this.commonService.getNRemoveData(
      "socialAccountLinkedStatus"
    );
    /* CLEAR MESSAGE AFTER TIMES: 10 SECONDS */
    setTimeout(() => {
      delete this.tempData.socialAccountLinkedStatus;
    }, 10000);
    /* END */

    /* CHECK IF ACCOUNT CAN BE DELETABLE */
    /* this.userService.checkAccountDeletable((data: any) => {
            this.userData.deletable = data.deletable;
        }); */

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  /* KEY = TYPE */
  makeSocialUserMap() {
    let map = {};
    for (let user of this.userData.socialUser) {
      map[`type_${user.type}`] = user;
    }
    this.userData.socialUserMap = map;
  }

  setFormValue(event: any, inputName: string) {
    this.userDataForm.controls[inputName].setValue(event.target.value);
    if (inputName == "birth_date") {
      if (
        event.target.value.length == 10 &&
        this.moment(event.target.value, "YYYY/MM/DD", true).isValid() === true
      ) {
        this.userData.age = this.moment().diff(event.target.value, "years");
      } else {
        this.userData.age = null;
      }
    }
  }

  async onSubmit() {
    this.tempData.formSubmitted = true;

    /* FORM ZEN TO HAN */
    this.commonService.convertFormInputZenToHan(this.userDataForm);
    this.formValidationInit();

    if (this.userDataForm.invalid) {
      /* SCROLL TO THE FIRST ERROR FORM */
      if (this.$(".form-error-msg:visible").length !== 0) {
        this.$("html, body").animate(
          {
            scrollTop:
              this.$(".form-error-msg:visible").first().offset().top - 90,
          },
          200
        );
      }
      return false;
    }

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("処理中・・・");

    /* CLEAR LAST ERROR MESSAGES */
    delete this.tempData.updateProfileInfoStatus;

    let tel: any = {};
    let birthday: any = {};
    if (this.userDataForm.value.birth_date != "") {
      let newBirthday = this.userDataForm.value.birth_date
        .toString()
        .replace(/[/]/g, "");
      birthday = {
        birth_date1: newBirthday.substr(0, 4),
        birth_date2: newBirthday.substr(4, 2),
        birth_date3: newBirthday.substr(6, 2),
      };
    }

    if (this.userDataForm.value.tel != "") {
      let telParts = this.commonService.getBBTelParts(
        this.userDataForm.value.tel
      );
      if (!this._.isEmpty(telParts)) {
        tel = {
          tel1: telParts[0],
          tel2: telParts[1],
          tel3: telParts[2],
        };
      }
    }

    /* mail_magazine_type */
    let mail_magazine_type: any =
      this.userDataForm.value["mail_magazine1_type"] == "1" ||
      this.userDataForm.value["mail_magazine1_type"] == "true"
        ? 1
        : 0;

    mail_magazine_type = {
      mail_magazine1_type: mail_magazine_type,
      mail_magazine2_type: mail_magazine_type,
      mail_magazine3_type: mail_magazine_type,
    };
    /* END */

    let postData = Object.assign(
      this.userDataForm.value,
      mail_magazine_type,
      birthday,
      tel
    );
    postData.email2 = postData.email2 != null ? postData.email2 : "";

    let postString = this.commonService.objectToString(postData);
    let returnData = await this.userService.updateProfileInfo(postString);

    if (returnData && returnData.status == "success") {
      this.tempData.updateProfileInfoStatus = {
        status: "success",
        message: "profile.alert.updateSuccess",
      };

      /* HIDE ALERT MESSAGE */
      let self = this;
      setTimeout(function () {
        delete self.tempData.updateProfileInfoStatus;
      }, 3000);
    } else {
      this.tempData.updateProfileInfoStatus = {
        status: "danger",
        message: "profile.alert.updateFailed",
      };
    }

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  async onSubmitDelete() {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("処理中・・・");

    /* CLEAR LAST ERROR MESSAGES */
    delete this.tempData.deleteAccountStatus;

    let returnData = await this.userService.deleteAccount({
      customerID: this.userData.id,
    });

    if (returnData && returnData.status == "success") {
      this.authService.logout();

      this.tempData.deleteAccountStatus = {
        status: "success",
        message: "profile.alert.deleteAccountSuccess",
      };

      window.location.href = window.location.origin;
    } else {
      this.tempData.deleteAccountStatus = {
        status: "danger",
        message: "profile.alert.deleteAccountFailed",
      };
    }

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  checkBoxChecking(event: any) {
    let success = false;

    if (event.target.checked == true) {
      this.checkboxes[event.target.name] = "on";
    } else {
      this.checkboxes[event.target.name] = "off";
    }

    let count = 0;
    for (var key in this.checkboxes) {
      if (this.checkboxes[key] == "on") {
        count++;
      }
    }

    if (count == 3) {
      this.deleteOn = "off";
    } else {
      this.deleteOn = "on";
    }
  }

  async checkEmailNUsername(type: any, value: any) {
    this.emailNUsernameCheckData.isChecking = true;

    if (type && value) {
      if (["email", "username"].indexOf(type) !== -1) {
        /* PRE CHECK */
        switch (type) {
          case "email":
            if (this.userDataForm.controls.email1.errors) {
              this.emailNUsernameCheckData.isChecking = false;
              return false;
            } else if (value == this.userData.email1) {
              this.emailNUsernameCheckData.isChecking = false;
              this.emailNUsernameCheckData.email.hasError = false;
              this.emailNUsernameCheckData.email.successMessage = null;
              return false;
            }
            break;

          case "username":
            if (this.userDataForm.controls.username.errors) {
              this.emailNUsernameCheckData.isChecking = false;
              return false;
            } else if (value == this.userData.username) {
              this.emailNUsernameCheckData.isChecking = false;
              this.emailNUsernameCheckData.username.hasError = false;
              this.emailNUsernameCheckData.username.successMessage = null;
              return false;
            }
            break;
        }

        /* API CHECK */
        let data = {
          type: type,
          checking_data: value,
        };

        let returnedData = await this.userService.existChecking(data);

        switch (type) {
          case "email":
            if (returnedData.status == "success") {
              this.emailNUsernameCheckData.email.hasError = false;
              this.emailNUsernameCheckData.email.successMessage = "success";
            } else {
              this.emailNUsernameCheckData.email.hasError = true;
              this.emailNUsernameCheckData.email.errorMessage =
                returnedData.message.email1;
              this.emailNUsernameCheckData.email.successMessage = null;
            }
            break;

          case "username":
            if (returnedData.status == "success") {
              this.emailNUsernameCheckData.username.hasError = false;
              this.emailNUsernameCheckData.username.successMessage = "success";
            } else {
              this.emailNUsernameCheckData.username.hasError = true;
              this.emailNUsernameCheckData.username.errorMessage =
                returnedData.message.username;
              this.emailNUsernameCheckData.username.successMessage = null;
            }
            break;
        }
      } else {
        this.emailNUsernameCheckData.email.hasError = true;
        this.emailNUsernameCheckData.email.errorMessage =
          "reservation.error.newEmail";
        this.emailNUsernameCheckData.username.hasError = true;
        this.emailNUsernameCheckData.username.errorMessage =
          "reservation.error.newUsername";
      }
    }

    this.emailNUsernameCheckData.isChecking = false;
  }

  linkWithSocialAccount(type: any) {
    this.commonService.setCurrentURL(
      window.location.origin +
        this.commonService.routePaths.pageProfileIndexNoParam
    );

    switch (type) {
      case 1 /* FACEBOOK */:
        this.authService.redirectToFacebookLogin();
        break;

      case 2 /* LINE */:
        this.authService.redirectToLineLogin();
        break;

      case 3 /* GOOGLE */:
        this.authService.redirectToGoogleLogin();
        break;

      case 4 /* YAHOO JP */:
        this.authService.redirectToYahooJPLogin();
        break;

      case 5 /* INSTAGRAM */:
        this.authService.redirectToInstagramLogin();
        break;

      case 6 /* TWITTER */:
        this.authService.redirectToTwitterLogin();
        break;
    }
  }

  inlineJS() {
    let self = this;

    self.$(function () {
      self.formValidationInit();

      /* INIT INPUT ZEN TO HAN */
      self.commonService.zenToHan();
    });
  }

  formValidationInit() {
    new Cleave(".js-birthday", {
      delimiter: "/",
      blocks: [4, 2, 2],
    });
  }
}
